import axios from '@/utils/noToastAxios';

// 初始化
export const onGetInitDataAPI = (params) => {
    return axios({ url: '/lost/drainage/init', method: 'POST', params }, { interceptResultCode: false });
};

// 领取相遇礼奖励
export const receiveMeetRewardAPI = (params) => {
    return axios({ url: '/lost/drainage/ordinary', method: 'POST', params }, { interceptResultCode: false });
};

// 领取回馈礼奖励
export const receiveRepayRewardAPI = (params) => {
    return axios({ url: '/lost/drainage/store', method: 'POST', params }, { interceptResultCode: false });
};

// 获取角色列表
export const GetRoleList = (params) => {
    return axios({ url: `/game/server`, method: 'GET', params });
};


// WEBPACK FOOTER //
// ./src/pages/mitu/drainage/api.js